import API from "../helpers/API"

const SiteEventController = {
  reportEvent(sessionId, st_event, ds_metadata = null, token = null) {
    return API.request(
      "/v1/site/events",
      { ds_session_id: sessionId, st_event, ds_metadata, token },
      "POST"
    )
  },
}

export default SiteEventController
